import CloseIcon from 'Components/Icons/CloseIcon'
import AttorneyDashboardInfo from 'Components/Profile/AttorneyDashboardInfo'
import useIsMobile from 'Hooks/useIsMobile'
import React from 'react'
import ReactModal from 'react-modal'

function TeamupDashboardMobileModal({uploadNew, onClose,
     selected,
    userInfo,
    confirmTeamup,
    deleteTeamup,
    showHoverMsg,
    setShowHoverMsg,
    hoverMessage,
    cardBuilder
}) {
    const isMobile = useIsMobile();
  return (
    <ReactModal
    shouldCloseOnEsc = {true}
    shouldCloseOnOverlayClick = {true}
    onRequestClose={onClose}
    isOpen = {uploadNew}
    style={{
        overlay: { zIndex: 55, backgroundColor: 'rgba(20,33,61,.45)' },
        content: { zIndex: 55, inset: 0, width: '100%', height: '100%', padding: 0, border: 'none', borderRadius: 0, background: '#f7f4ed', overflowY: 'auto' }
      }}
    >
        <div className='w-full font-plexsans'>
            <div className='sticky top-0 z-[2] flex items-center justify-between py-3.5 px-4 bg-white border-b border-navy/[.1]'>
                <span onClick={onClose} className='flex items-center gap-1.5 font-plexsans font-medium text-[14px] leading-none text-brass cursor-pointer'>
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"><path d="M15 6l-6 6 6 6"/></svg>Back
                </span>
                <span className='font-plexsans font-semibold text-[14px] leading-none text-navy'>{selected?.caseDetails?.caseNumber}</span>
                <span className='w-10' />
            </div>
            <div className='p-3.5'>
            <AttorneyDashboardInfo
            userInfo={userInfo}
            selected={selected}
            cardBuilder={cardBuilder}
            confirmTeamup={confirmTeamup}
            deleteTeamup={deleteTeamup}
            showHoverMsg={showHoverMsg}
            setShowHoverMsg={setShowHoverMsg}
            hoverMessage={hoverMessage}
            />
            </div>
        </div>
    </ReactModal>
  )
}

export default TeamupDashboardMobileModal